/**
 * If enabled, auto-extend a new Faire Direct retailer's credit by 3 more days.
 * PRD: https:www.notion.so/Auto-extend-FD-Credit-for-3-Days-XP-890e63dd95dc4db2a89d7cf7d9e3a931.
 */
export const ENABLE_FAIRE_DIRECT_AUTO_EXTEND_FIRST_ORDER_INCENTIVE_240212 = 'ENABLE_FAIRE_DIRECT_AUTO_EXTEND_FIRST_ORDER_INCENTIVE_240212';
